import { baseUrl } from '@fs/zion-config'

export const _ = () => {}

/* Initial chat server environment */
// const DOMAIN_HOST = 'jabber.rootstechchat.org'
// const DOMAIN_PORT = ':5443'

/* Beta chat server environment, when ready. */
const NAMESPACE = 'chat.rootstech.org'

// FIXME:  Useing hard coded ugly DNS name for lower reference testing until nice routes are configured
const IS_PRODUCTION = baseUrl.includes('www')
const DOMAIN_HOST = IS_PRODUCTION ? 'chat.rootstech.org' : 'RtcDevVpcFrontEndAlb-1270801753.us-east-1.elb.amazonaws.com'
const DOMAIN_PORT = '' // 443, not required

export const Chat = {
  Settings: {
    DOMAIN: `${NAMESPACE}`,
    SEARCH_DOMAIN: `vjud.${NAMESPACE}`,
    BOSH_URL: `http://${DOMAIN_HOST}${DOMAIN_PORT}/bosh`,
    WS_URL: `wss://${DOMAIN_HOST}${DOMAIN_PORT}/ws`,
    MUC_DOMAIN: `conference.${NAMESPACE}`,

    TIMEOUT: 10000,
    AUTO_ACCEPT_ROSTER_INVITES: true,
    LOG_SERVER_INTERACTIONS: false, // Only set to true if you want logging done in upper lanes!
    AUTO_ACCEPT_PRIVATE_CHAT_INVITES: true,
    DEFAULT_CHAT_HISTORY_COUNT: 30,
    DEFAULT_LOW_BANDWIDTH_CHAT_HISTORY_COUNT: 10,
    CHAT_STATE_TIMEOUT: 5000,
    PING_INTERVAL: 600000, // 10 min
    PRIVATE_CHAT_ROOM_PREFIX: 'private_',
    MAX_USERS_IN_ROOM: 1000,

    KEEP_TABS_IN_SYNC_DIRECT_CHAT: true,

    ASK_EXPERT_ENABLED: false, // keep chat available, but turn off Ask us Anything, Ask an Expert features.
    SITE_CHAT_ENABLED: !IS_PRODUCTION, // disable chat for the entire site. Turn off the ASK_EXPERT_ENABLED too.
  },

  // Namespaces defined here:
  // https://xmpp.org/registrar/namespaces.html

  NS: {
    CARBONS: 'urn:xmpp:carbons:2',
    CHATSTATES: 'http://jabber.org/protocol/chatstates',
    DISCO_ITEMS: 'http://jabber.org/protocol/disco#items',
    DISCO_INFO: 'http://jabber.org/protocol/disco#info',
    IMPROMPTU: 'http://rootstech.org/impromptu',
    MAM_2: 'urn:xmpp:mam:2',
    MUC: 'http://jabber.org/protocol/muc',
    MUC_OWNER: 'http://jabber.org/protocol/muc#owner',
    MUC_ROOMCONFIG: 'http://jabber.org/protocol/muc#roomconfig',
    PING: 'urn:xmpp:ping',
    ROSTER: 'jabber:iq:roster',
    RSM: 'http://jabber.org/protocol/rsm',
    RTC_MESSAGE: 'urn:xmpp:rtc-message',
    SID: 'urn:xmpp:sid:0',
    XCONFERENCE: 'jabber:x:conference',
    XFORM: 'jabber:x:data',
  },

  PersonStatus: {
    AWAY: 'away',
    BUSY: 'dnd',
    OFFLINE: 'offline',
    ONLINE: 'online',
    UNAVAILABLE: 'unavailable',
    GONE: 'xa',
  },

  ChatState: {
    ACTIVE: 'active',
    COMPOSING: 'composing',
    GONE: 'gone',
    INACTIVE: 'inactive',
    PAUSED: 'paused',
  },

  Errors: {
    CONFERENCE_ROOM_DOES_NOT_EXIST: 'Conference room does not exist',
    TOO_MANY_USERS_IN_CHAT_ROOM: 'Too many users in this conference',
    ONLY_OCCUPANTS_CAN_SEND_MESSAGES: 'Only occupants are allowed to send messages to the conference',
  },
}
